<div [class.images-presentation--loaded]="preloaded" class="images-presentation">
    <div *ngIf="preloaded" class="images-presentation-images">
        <div [class.no-thumbs]="!_showThumbs" class="art-presentation-outer">
            <owl-carousel #owlMain [carouselClasses]="options.owlMainClasses" [options]="owlMainOptions"
                          data-owl-carousel="art-presentation" id="{{options.owlID}}">
                <div *ngFor="let image of images; let index = index" class="owl-slide">
                    <div class="grid-item-inner">
                        <a (click)="openModal(index, $event)" href="#{{!disableModal ? options.modalID : ''}}">
                            <img #mainImage [attr.alt]="image.alt ? image.alt : ''" appLazyLoad class="grid-figure"
                                 src="{{image.thumbnails[options.imageSize].url}}"/>
                        </a>
                    </div>
                </div>
            </owl-carousel>
        </div>

        <div *ngIf="_showThumbs" class="art-thumbs-outer">
            <div class="{{_classes.thumbsClasses}}">

                <ul *ngIf="!mainThumbsUseCarousel" class="{{_classes.thumbsListClasses}}">
                    <li *ngFor="let image of images; let index = index" class="art-thumb-item">
                        <a (click)="mainGoTo(index, $event)"
                           [ngStyle]="{'background-image': 'url(' + image?.thumbnails?.detail.url + ')'}"
                           class="art-thumb-link"
                           href="#{{!disableModal ? options.modalOwlID : ''}}"></a>
                    </li>
                </ul>

                <owl-carousel #owlMainThumbs *ngIf="mainThumbsUseCarousel"
                              [carouselClasses]="_classes.thumbsListClasses"
                              [options]="owlMainThumbsOptions">
                    <div *ngFor="let image of images; let index = index" class="owl-slide art-thumb-item">
                        <div class="grid-item-inner">
                            <a (click)="mainGoTo(index, $event)" [ngStyle]="{
                                'background-image': 'url('+image.thumbnails[options.imageSize].url+')'
                            }"
                               class="art-thumb-link" href="#{{!disableModal ? options.modalID : ''}}"></a>
                        </div>
                    </div>
                </owl-carousel>

            </div>
        </div>
    </div>

    <div *ngIf="preloaded && !disableModal" class="images-presentation-modal">
        <div #modal="bs-modal" #modalEl bsModal class="modal fade work-presentation-modal" id="{{options.modalID}}"
             role="dialog" tabindex="-1">
            <div class="modal-dialog-content no-padding">
                <button (click)="closeModal($event)" aria-label="Zamknij" class="close close-icon"
                        type="button"></button>

                <div class="zoom-buttons">
                    <button (click)="zoomHelper.zoomIn()" class="zoom-in"></button>
                    <button (click)="zoomHelper.zoomOut()" class="zoom-out"></button>
                </div>

                <div (mousedown)="zoomHelper.mouseDown($event)" (mousemove)="zoomHelper.mouseMove($event)"
                     (mouseup)="zoomHelper.mouseUp()"
                     (mousewheel)="zoomHelper.zoomImage($event)"
                     (wheel)="zoomHelper.zoomImage($event)"
                     [ngStyle]="zoomHelper.zoom.style.cursor"
                     class="modal-dialog-inner modal-dialog full-width"
                     role="document">
                    <div class="art-presentation-outer container full-width">
                        <owl-carousel #owlModal [carouselClasses]="options.owlModalClasses" [options]="owlModalOptions"
                                      id="{{options.modalOwlID}}">
                            <div *ngFor="let image of images" class="owl-slide" style="overflow: hidden;">
                                <div [ngStyle]="zoomHelper.zoom.style.imageContainerHandler" class="handler">
                                    <div [ngStyle]="{
                                         transform: zoomHelper.zoom.style.imageContainer.transform,
                                         backgroundImage: 'url(' + image?.thumbnails?.original.url + ')',
                                         backgroundSize: 'contain',
                                         backgroundPosition: 'center center',
                                         backgroundRepeat: 'no-repeat'
                                         }"
                                         class="grid-item-inner">
                                    </div>
                                </div>
                            </div>
                        </owl-carousel>

                        <div #thumbs (mouseenter)="onMouseenterThumbs()"
                             (mouseleave)="onMouseleaveThumbs()"
                             [class.show]="_showThumbs" class="art-thumbs">
                            <owl-carousel #owlThumbs [carouselClasses]="_classes.owlThumbsClasses"
                                          [options]="owlThumbsOptions">
                                <div *ngFor="let image of images; let index = index" class="art-thumb-item owl-slide">
                                    <a (click)="modalGoTo(index, $event); mainGoTo(index)"
                                       [ngStyle]="{'background-image': 'url(' + image?.thumbnails?.detail.url + ')'}"
                                       class="art-thumb-link"
                                       href="#{{options.modalID}}"></a>
                                </div>
                            </owl-carousel>
                        </div>
                    </div>
                </div>
            </div>

            <div #nav class="owl-nav wrapper-container"></div>
        </div>
    </div>
</div>
